<template>
  <vx-card v-if="permissions" no-shadow>
    <h2 class="mb-6">Permissions</h2>

    <vs-collapse type="margin">
      <vs-collapse-item v-for="(service, idxS) in getServices" :key="idxS">
        <div slot="header">
          <span>{{ service.service }}</span>
        </div>
        <vs-list
          v-for="(group, idxG) in getGroupsByService(service.service)"
          :key="idxG"
        >
          <vs-list-header
            icon="supervisor_account"
            :title="group.group"
          ></vs-list-header>
          <vs-list-item
            :icon="perm.entitySpecific ? 'verified_user' : 'public'"
            v-for="(perm, idxP) in getPermissionsInGroup(
              group.group,
              group.service
            )"
            :key="idxP"
            :title="perm.title"
            :subtitle="perm.description + ' (' + perm.id + ')'"
          >
            <template slot="avatar">
              <!--<vs-checkbox :vs-value="true" color="primary" />-->
              <role-permission-checkbox
                :permission="perm"
                @addGlobalPermission="addGlobalPermission"
                @removeGlobalPermission="removeGlobalPermission"
                @addEntityPermission="addEntityPermission"
                @removeEntityPermission="removeEntityPermission"
                :userGlobalPermissions="userGlobalPermissions"
                :userEntityPermissions="userEntityPermissions"
              />
            </template>
          </vs-list-item>
        </vs-list>
      </vs-collapse-item>
    </vs-collapse>
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="savePermissions" v-if="hasPermission('life.admin.roles.edit')" id="save-button" class="ml-auto mt-2"
        >Save Changes</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import _ from "lodash";
import RolePermissionCheckbox from "./RolePermissionCheckbox.vue";
export default {
  components: { RolePermissionCheckbox },
  props: ["role"],

  data() {
    return {
      permissions: null,
      userEntityPermissions: [],
      userGlobalPermissions: [],
    };
  },
  computed: {
    getServices() {
      return _.uniqBy(this.permissions, (e) => e.service);
    },
  },
  methods: {
    isChecked() {
      return true;
    },
    isAllowedInput(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z-.]+$/.test(char)) return true;
      else e.preventDefault();
    },
    numPermissionsByService(service) {
      return this.permissions.filter((e) => e.service === service).length;
    },
    getGroupsByService(service) {
      return _.uniqBy(
        this.permissions.filter((e) => e.service === service),
        (e) => e.group
      );
    },
    getPermissionsInGroup(group, service) {
      return this.permissions.filter(
        (p) => p.group === group && p.service === service
      );
    },
    getPermissions: function () {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/Idam/Permissions";

      this.$http
        .get(url)
        .then((resp) => {
          console.log(resp.data);
          this.permissions = resp.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    savePermissions() {
      this.$vs.loading();

      const payload = {
        ...this.role,
        globalPermissions: this.userGlobalPermissions,
        entityPermissions: this.userEntityPermissions,
      };

      const url = process.env.VUE_APP_API + "/Idam/Roles";
      this.$http
        .put(url, payload)
        .then((resp) => {
          console.log(resp.data);

          if (resp.data.success === true) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Role updated",
            });

            this.$emit("updateRole", payload);
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Could not update role: " + resp.data.error,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not update role" + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    addGlobalPermission(id) {
      if (!this.userGlobalPermissions.includes(id))
        this.userGlobalPermissions.push(id);
    },
    removeGlobalPermission(id) {
      this.userGlobalPermissions = _.filter(
        this.userGlobalPermissions,
        (e) => e !== id
      );
    },
    addEntityPermission(id) {
      if (!this.userEntityPermissions.includes(id))
        this.userEntityPermissions.push(id);
    },
    removeEntityPermission(id) {
      this.userEntityPermissions = _.filter(
        this.userEntityPermissions,
        (e) => e !== id
      );
    },
  },
  created() {
    this.getPermissions();
  },
  mounted() {
    this.isMounted = true;
    this.userEntityPermissions = this.role.entityPermissions;
    this.userGlobalPermissions = this.role.globalPermissions;
  },
};
</script>

<style lang="scss">
.vs-collapse-item--header {
  font-weight: 700;
  font-size: 20;
}
.list-titles:nth-child(1) .vs-list--title {
  font-weight: 500;
  font-size: 17px;
  color: #666;
}
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

.con-vs-dialog .vs-dialog {
  max-width: 600px;
}
.questionDisabled {
  opacity: 0.5;
}
</style>
